import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const useCloseOnRouteChange = (closeFn) => {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      closeFn();
      prevPathname.current = pathname;
    }
  }, [pathname, closeFn]);
};
